import script from "./CollectionCommunityActivityStats.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionCommunityActivityStats.vue?vue&type=script&setup=true&lang=js"

import "./CollectionCommunityActivityStats.vue?vue&type=style&index=0&id=1e459b4c&lang=scss"

const __exports__ = script;

export default __exports__